import { useState } from 'react'

import { api } from '../api/client'
import { useAsync } from '../hooks/useAsync'
import { t } from '../i18n/lingua'
import { Card, ErrorBanner, formatDateTime, Spinner } from './common'

/**
 * L'ambiente di esempio del tenant: c'è, da quando, e il pulsante per
 * passare all'ambiente vuoto (o per caricarlo, se il tenant è vuoto). Vedi
 * `demo_data_service` nel Control Plane: si toglie tutto ciò che è di
 * esempio e solo quello.
 */
export function DatiDiEsempio() {
  const stato = useAsync(() => api.demoData(), [])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const d = stato.data

  async function svuota() {
    if (!window.confirm(t('Togliere tutti i dati di esempio? I dati veri, se ci sono, restano.'))) return
    setBusy(true)
    setError(null)
    try {
      await api.clearDemoData()
      window.location.reload()
    } catch (e) {
      setError(e)
      setBusy(false)
    }
  }

  async function carica() {
    setBusy(true)
    setError(null)
    try {
      await api.loadDemoData()
      window.location.reload()
    } catch (e) {
      setError(e)
      setBusy(false)
    }
  }

  return (
    <Card title={t('Dati di esempio')}>
      <ErrorBanner error={error ?? stato.error} />
      {stato.loading && !d ? (
        <Spinner />
      ) : d?.loaded ? (
        <>
          <p>
            {t('Stai guardando l’ambiente di esempio di CENSO: una sede con la sua rete, due host VMware con le macchine virtuali, un server fisico, stampanti, UPS, storage, un account AWS con i costi, rischi di sicurezza e contratti.')}{' '}
            {d.loaded_at && t('Caricato il {quando}.', { quando: formatDateTime(d.loaded_at) })}{' '}
            {t('{n} CI di esempio su {tot}.', { n: d.demo_cis, tot: d.total_cis })}
          </p>
          <p className="text-muted">
            {t('Quando sei pronto a collegare le tue sonde, passa all’ambiente vuoto: si toglie tutto ciò che è di esempio e solo quello. Non si torna indietro, ma i dati veri arrivano con la prima scansione.')}
          </p>
          <button type="button" className="danger" onClick={() => void svuota()} disabled={busy}>
            {busy ? t('Un attimo…') : t('Passa all’ambiente vuoto')}
          </button>
        </>
      ) : (
        <>
          <p className="text-muted">
            {d?.can_load
              ? t('Il tenant è vuoto. Puoi caricare l’ambiente di esempio per vedere la piattaforma popolata: una sede, i suoi server, un account cloud, rischi e contratti.')
              : d?.trial
                ? t('I dati di esempio si caricano solo in un tenant senza CI: qui ci sono già dati veri.')
                : t('L’ambiente di esempio è riservato ai tenant in prova.')}
          </p>
          {d?.can_load && (
            <button type="button" className="secondary" onClick={() => void carica()} disabled={busy}>
              {busy ? t('Un attimo…') : t('Carica l’ambiente di esempio')}
            </button>
          )}
        </>
      )}
    </Card>
  )
}
